<button class="button-location-back" matRipple (click)="backClick.emit()">
  <mat-icon class="icon" aria-hidden="true">arrow_back</mat-icon>
  <ng-content></ng-content>
</button>
